export default {
  user_token:"",
  user_info:"",
};



// WEBPACK FOOTER //
// ./src/store/state.js